<canvas #animationContainer class="animation"></canvas>
